import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {NgClass, NgIf, NgStyle} from '@angular/common';
import {CardButtonComponent} from '../card-button/card-button.component';
import {NgReplacePipeModule} from 'angular-pipes';
import {PipesModule} from '../../../../pipes/pipes.module';

@Component({
  selector: 'app-card-text',
  templateUrl: './card-text.component.html',
  styleUrls: ['./card-text.component.scss'],
  standalone: true,
  imports: [NgStyle, NgClass, NgIf, CardButtonComponent, NgReplacePipeModule, PipesModule],
  encapsulation: ViewEncapsulation.None,
})
export class CardTextComponent implements OnInit {
  @Input() set text(value: string | undefined) {
    let text = value || '';
    text = text.replace(/\n/g, '<br>');
    text = text.replace(/&nbsp;/g, ' ');
    text = text.replace(/<p\b[^>]*>\s*<\/p>/g, '<p>&nbsp;</p>');
    this._text = text;
  };
  @Input() color: string = '#4f4f4f';

  _text: string = '';

  constructor() {
  }

  ngOnInit() {
  }
}
